const BgStickyGradient = () => (
  <div
    aria-hidden="true"
    style={{
      zIndex: 0,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: 0,
      display: 'flex',
      position: 'sticky',
      top: 0,
      overflow: 'hidden',
      backgroundColor: '#000C0D'
    }}
    className="bg-sticky">
    <div
      className="bg-light-drift bg-sticky-gradient"
      style={{
        width: '133.333%',
        height: '124.015%',
        display: 'block',
        position: 'absolute'
      }}
    />
    <div
      style={{
        zIndex: 2,
        WebkitBackdropFilter: 'blur(110.973px)',
        backdropFilter: 'blur(110.973px)',
        backgroundColor: '#ffffff03',
        width: '100%',
        height: '100%',
        position: 'absolute'
      }}
    />
  </div>
);

export default BgStickyGradient;
